import { Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, ViewChild, ContentChild, TemplateRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import _ from 'lodash';
import { BroadCastService } from '../../services/broadcast.service';
@Component({
  standalone: false,
  selector: 'mysynch-simple-select',
  templateUrl: '../app/form-controls/mysynch-simple-select/mysynch-simple-select.view.html',
  styleUrls:['../app/form-controls/mysynch-simple-select/mysynch-simple-select.style.css','../css/ng-select/default.theme.css','../css/ng-select/ng-select.component.css']
})
export class MySynchSimpleSelect implements OnInit, OnDestroy {

    @ViewChild('ngSelectRef') ngSelect!: NgSelectComponent;

    @ContentChild('customOption') customOptionTemplate!: TemplateRef<any>;
    @ContentChild('customLabel') customLabelTemplate!: TemplateRef<any>;

    @Input() set selectSize(value: string) {
        this._selectSize = value;
        this.selectSizeClass = `select-size-${value}`;
    }
    get selectSize(): string {
        return this._selectSize;
    }
    private _selectSize: string = "large";
    selectSizeClass: string = "select-size-large";

    @Input() isDisabled: boolean = false;
    @Input() defaultSelectedItem:any = null;
    @Input() controlId:any = "mysynchSimpleSelect";


    @Input() placeholder: string = "Select";
    @Input() closeOnSelect: boolean = true;
    @Input() multiple: boolean = false;
    @Input() searchable: boolean = false;
    @Input() virtualScroll: boolean = false;
    @Input() appendTo: string|null = null;
    
    //@Input() selectedItem:any = this.defaultSelectedItem;
    _selectedItem:any = this.defaultSelectedItem;
    @Input() set selectedItem(value: any) {
      this._selectedItem = value;
    }
    get selectedItem(): any {
      return this._selectedItem;
    }

    _items: any[] = [];
    @Input() set items(items: any[]){
        this._items = items;
    };
   
    @Output() onSelectChange = new EventEmitter<any[]>();
    @Output() onSelectOpen = new EventEmitter<any>();
    @Output() onSelectClose = new EventEmitter<any>()


    private onClearControlSubscription: any;
    
    
    
    _:any;
    
    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject(BroadCastService) private broadCastSrv:BroadCastService){
      this._ = _;
    }
    ngOnInit(){
      this.onClearControlSubscription = this.broadCastSrv.onClearControl().subscribe((controlId)=>{
          if(_.isEqual(controlId,this.controlId)){
            this._selectedItem = this.defaultSelectedItem;
          }
       });
    }

    ngOnDestroy(){
      if(this.onClearControlSubscription){
        this.onClearControlSubscription.unsubscribe();
      }
      this.onSelectChange.complete();
      this.onSelectOpen.complete();
      this.onSelectClose.complete();
    }

    trackByFn = (item:any)=>{
      return item;
   }

    get items():any[] {
      return this._items;
    }

    onOpen(){
     this.onSelectOpen.emit();
    }
    onClose(){
     this.onSelectClose.emit();
    }
    
    onChange(options:any):void{
        this.onSelectChange.emit(options);   
   }

    closeDropdown() {
      if (this.ngSelect) {
        this.ngSelect.close();
      }
    }
   
}